import { makeAutoObservable } from "mobx";
import Auth from "../api/auth/auth";
import { getError } from "../util/util";

export class AuthStore {
  rootStore;

  sesionCerradaPorInactividad = false  
  loading = false;

  constructor(rootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }

  setCerrarSesionPorInactividad = (value) => {
    this.sesionCerradaPorInactividad = value
  }

  iniciarSesion = async (data) => {
    this.loading = true;
    try {
      const result = await Auth.iniciarSesion(data);
      return Promise.resolve(result);
    } catch (error) {
      this.displayError(error);
      return Promise.resolve(error);
    } finally {
      this.loading = false;
    }
  };

  enviaCodigoAutenticacion = async () => {
    this.loading = true;
    try {
      const result = await Auth.enviaCodigoAutenticacion();
      return Promise.resolve(result);
    } catch (error) {
      this.displayError(error);
      return Promise.resolve(error);
    } finally {
      this.loading = false;
    }
  };

  validarCodigoAutenticacion = async (data) => {
    this.loading = true;
    try {
      const result = await Auth.validarCodigoAutenticacion(data);
      return Promise.resolve(result);
    } catch (error) {
      this.displayError(error);
      return Promise.resolve(error);
    } finally {
      this.loading = false;
    }
  };

  createUsuario = async (idOrganizacion, data) => {
    this.loading = true;
    try {
      const result = await Auth.createUsuario(idOrganizacion, data);
      return Promise.resolve(result);
    } catch (error) {
      this.displayError(error);
      return Promise.resolve(error);
    } finally {
      this.loading = false;
    }
  };

  displayError = (error) => {
    this.rootStore.alertStore.alertError(getError(error));
  };
}
